import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	limitReachedPopupContent: {
		id: 'servicedesk-external-links.links.limit-reached-popup.limit-reached-popup-content',
		defaultMessage: 'You’ve already added 10 links. Remove a link to add another one.',
		description: 'Popup content when user tries to 11th link',
	},
	editorInfoIconLabel: {
		id: 'servicedesk-external-links.links.limit-reached-popup.editor-info-icon-label',
		defaultMessage: 'Editor Info',
		description: 'Label text for Editor Info icon',
	},
	editorPanelIconLabel: {
		id: 'servicedesk-external-links.links.limit-reached-popup.editor-panel-icon-label',
		defaultMessage: 'Editor Panel',
		description: 'Label text for Editor Panel icon',
	},
});
